/* lt-features-page.js — Sticky nav · Hamburger · Scroll-reveal · Smooth anchors */

(function () {
  'use strict';

  // ── Sticky nav ────────────────────────────────────────────
  const nav = document.getElementById('ltf-nav');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 80) {
        nav.classList.add('ltf-scrolled');
      } else {
        nav.classList.remove('ltf-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Hamburger ─────────────────────────────────────────────
  const ham     = document.getElementById('ltf-ham');
  const mobNav  = document.getElementById('ltf-mob-nav');
  if (ham && mobNav) {
    ham.addEventListener('click', () => {
      const isOpen = mobNav.classList.toggle('open');
      ham.classList.toggle('open', isOpen);
      ham.setAttribute('aria-expanded', isOpen);
    });
    // Close on link click
    mobNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobNav.classList.remove('open');
        ham.classList.remove('open');
        ham.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Smooth scroll for anchor links ────────────────────────
  document.querySelectorAll('.ltf-page a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const navH = nav ? nav.offsetHeight : 0;
      const top  = target.getBoundingClientRect().top + window.scrollY - navH;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  // ── Scroll-reveal (IntersectionObserver) ─────────────────
  const revealEls = document.querySelectorAll('.ltf-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ltf-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(el => io.observe(el));
  } else {
    // Fallback: show all immediately
    revealEls.forEach(el => el.classList.add('ltf-visible'));
  }

})();
